export function isValidImage(field?: any): boolean {
  if (field && field.value && field.value.src) {
    return field.value.src.trim() !== '';
  }
  return false;
}
